import { Activity, BarChart3, Brain, FileText, Map as MapIcon, Tags } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface DashboardTab {
  /** The URL segment after `/agents/seo`, or `''` for the Overview, which is the bare path. */
  segment: string;
  label: string;
  icon: LucideIcon;
}

/** The dashboard's tabs, in the order the bar shows them. Each one is its own URL. */
export const DASHBOARD_TABS: readonly DashboardTab[] = [
  { segment: '', label: 'Overview', icon: FileText },
  { segment: 'strategy', label: 'Strategy', icon: MapIcon },
  { segment: 'keywords', label: 'Keywords', icon: Tags },
  { segment: 'content', label: 'Content', icon: FileText },
  { segment: 'activity', label: 'Activity', icon: Activity },
  { segment: 'analytics', label: 'Analytics', icon: BarChart3 },
  { segment: 'brand-reviews', label: 'Brand Reviews', icon: Brain },
];
